import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-oracle-hcm-cloud',
  templateUrl: './oracle-hcm-cloud.component.html',
  styleUrls: ['./oracle-hcm-cloud.component.scss']
})
export class OracleHCMCloudComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
